namespace info.imagelogic.NumberTools{

	export function zerofill(num:any, totalLength:number = 2){
		let str = parseInt(num).toString();

		while(str.length < totalLength){
			str = "0" + str;
		}
		return str;
	}


}